import * as Yup from "yup";
import { DocumentType } from "../../../../enums";

export const YesOrNo = ["Yes", "No"] as const;

export const VisaTypes = [
  "Permanent Resident Card or Alien Registration Receipt Card (Form I- 551)",
  "Employment Authorization Document (Form I- 766)",
  "Other",
] as const;

export const EmployeeSchema = Yup.object({
  company: Yup.string(),
  companyId: Yup.string(),
  title: Yup.string().required("Position Required"),
  associateId: Yup.string(),
  [DocumentType.EMPLOYMENT_CONTRACT]: Yup.mixed(),
  [DocumentType.POLICIES_ACKNOWLEDGEMENTS]: Yup.mixed(),
  workVisaType: Yup.mixed().oneOf([...VisaTypes]),
  workVisaOther: Yup.string(),
  workVisaRequirement: Yup.mixed().oneOf([...YesOrNo]),
  workVisaExpirationDate: Yup.date().min(new Date()),
  carYear: Yup.number().max(new Date().getFullYear() + 2),
  carMake: Yup.string(),
  carModel: Yup.string(),
  carLicensePlate: Yup.string(),
  driversLicenseExpiration: Yup.date().min(new Date()),
  [DocumentType.STATE_LICENSE]: Yup.mixed(),
  [DocumentType.CERTIFICATIONS]: Yup.mixed(),
});

export type DocumentName =
  | DocumentType.EMPLOYMENT_CONTRACT
  | DocumentType.POLICIES_ACKNOWLEDGEMENTS
  | DocumentType.STATE_LICENSE
  | DocumentType.CERTIFICATIONS;

export type Employee = Yup.TypeOf<typeof EmployeeSchema>;
